<template>
  <div class="app-container">
    <div class="screeBox">
      <!-- <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.identifier"
        placeholder="请选择进出标识"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.car_number"
        placeholder="请输入车牌号模糊查询"
      ></el-input>
      <el-date-picker
        style="margin-right: 10px"
        value-format="yyyy-MM-dd"
        v-model="screen.start_time"
        type="daterange"
        placeholder="进场时间"
        start-placeholder="进场开始日期"
        end-placeholder="进场结束日期"
      >
      </el-date-picker>
      <el-date-picker
        style="margin-right: 10px"
        value-format="yyyy-MM-dd"
        v-model="screen.end_time"
        type="daterange"
        placeholder="出场时间"
        start-placeholder="出场开始日期"
        end-placeholder="出场结束日期"
      >
      </el-date-picker>

      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="100"> </el-table-column> -->

      <!-- <el-table-column label="是否离场" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.is_out_text }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="车牌号" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.car_number }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车辆类型" width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 0 ? "包月" : scope.row.type == 1 ? "临时" : ""
          }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="车牌颜色" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.car_color == 'blue'">蓝</span>
          <span v-if="scope.row.car_color == 'yellow'">黄</span>
          <span v-if="scope.row.car_color == 'white'">白</span>
          <span v-if="scope.row.car_color == 'green'">绿</span>
          <span v-if="scope.row.car_color == 'black'">黑</span>
          <span v-if="scope.row.car_color == 'unknow'">其他</span>
        </template>
      </el-table-column> -->
      <el-table-column label="进场时间">
        <template slot-scope="scope">
          <span>{{ scope.row.in_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="进场图片">
        <template slot-scope="scope">
          <p v-if="scope.row.in_image">
            <el-image
              :src="scope.row.in_image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="scope.row.in_image.split(',')"
            >
            </el-image>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="出场时间">
        <template slot-scope="scope">
          <span>{{ scope.row.out_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="出场图片">
        <template slot-scope="scope">
          <p v-if="scope.row.out_image">
            <el-image
              :src="scope.row.out_image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="scope.row.out_image.split(',')"
            >
            </el-image>
          </p>
        </template>
      </el-table-column>
      <!-- <el-table-column label="停留时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.time_count }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="created_at" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="examine(scope.row.id)"
            v-if="
              roles.includes('/carport/order_refund') &&
              scope.row.pay_status == 2 &&  scope.row.actual_receipt != 0 &&  scope.row.is_invoce == 0
            "
            >退款</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { get_car_record } from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "进",
          id: "in",
        },
        {
          title: "出",
          id: "out",
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        identifier: "",
        start_time: [],
        end_time: [],
        car_number: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    // this.getPark();
  },
  methods: {
    reset() {
      this.screen = {
        park_id: "-1",
        page: 1,
        page_size: 15,
        start_time: [],
        end_time: [],
        identifier: "",
        car_number: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      let data = {
        car_number: this.screen.car_number || "",
        page: this.screen.page,
        page_size: this.screen.page_size,
        park_id: this.screen.park_id || "",
        identifier: this.screen.identifier || "",
        in_start_time:
          this.screen.start_time && this.screen.start_time.length > 0
            ? this.screen.start_time[0]
            : "",
        in_end_time:
          this.screen.start_time && this.screen.start_time.length > 0
            ? this.screen.start_time[1]
            : "",
        out_start_time:
          this.screen.end_time && this.screen.end_time.length > 0
            ? this.screen.end_time[0]
            : "",
        out_end_time:
          this.screen.end_time && this.screen.end_time.length > 0
            ? this.screen.end_time[1]
            : "",
      };
      get_car_record(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
